// src/utils/widgetDataUpdater.ts

import { isPopularItemsWidget, isComboWidget } from './widgetPatterns';
import type { MenuItem } from '../redux/slices/menuSlice';

/**
 * Widget interface for type safety
 */
interface Widget {
  type: string;
  data: any;
}

/**
 * Update widgets with menu data for popular items widgets
 * @param widgets - Array of widgets to update
 * @param menuData - Menu data from API
 * @returns Updated widgets array
 */
export function updateWidgetsWithMenuData(widgets: Widget[], menuData: MenuItem[]): Widget[] {
  console.log('🔄 updateWidgetsWithMenuData - Input widgets:', widgets.map(w => w.type));
  console.log('🔄 updateWidgetsWithMenuData - Menu data length:', menuData.length);
  
  return widgets.map(widget => {
    console.log('🔍 Checking widget type:', widget.type, 'isPopularItemsWidget:', isPopularItemsWidget(widget.type));
    
    if (isPopularItemsWidget(widget.type)) {
      const existingSelectedIds = widget.data?.selectedItemIds || [];
      
      console.log('✅ Updating popular items widget:', widget.type, 'with menu data length:', menuData.length);
      
      // Don't auto-select items - keep existing selectedItemIds as-is
      return {
        ...widget,
        data: {
          ...widget.data,
          menuData: menuData,
          selectedItemIds: existingSelectedIds  // Keep existing, don't auto-select
        }
      };
    }
    return widget;
  });
}

/**
 * Update widgets with combo data for combo widgets
 * @param widgets - Array of widgets to update
 * @param comboData - Combo data from API
 * @returns Updated widgets array
 */
export function updateWidgetsWithComboData(widgets: Widget[], comboData: any[]): Widget[] {
  console.log('🔄 updateWidgetsWithComboData - Input widgets:', widgets.map(w => w.type));
  console.log('🔄 updateWidgetsWithComboData - Combo data length:', comboData.length);
  
  return widgets.map(widget => {
    console.log('🔍 Checking widget type:', widget.type, 'isComboWidget:', isComboWidget(widget.type));
    
    if (isComboWidget(widget.type)) {
      console.log('✅ Updating combo widget:', widget.type, 'with combo data length:', comboData.length);
      
      return {
        ...widget,
        data: {
          ...widget.data,
          combos: comboData
        }
      };
    }
    return widget;
  });
}
